import React, { useEffect, useState } from "react";
import styles from "./Canvas.module.scss";
import { ParseComponents } from "src/lib/dato/componentParser";

type Page = {
  id: string;
  layout: [];
  pageTitle: string;
};

const Canvas: React.FC<any> = (props) => {
  const [pages, setPages] = useState<Page[] | null>(null);

  useEffect(() => {
    setPages(props.data.data.book.pages);
  }, [props]);

  return (
    <div className={styles.CanvasWrapper}>
      <div className={styles.Canvas}>
        <ParseComponents data={pages}></ParseComponents>
      </div>
    </div>
  );
};

export default Canvas;
